import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { BrandContext } from '../../../../contextProviders/brandContext';
import { CSPUrlsMap } from '../../../../routes/CSPUrlsMap';
import { PolicyHolderPropTypes } from '../../../../propTypes/petDetails';
import { createAlias } from '../../../../utils/alias';

export const NameDetails = ({ policyHolder, numPolicyHolders = 1 }) => {
  const navigate = useNavigate();
  const {
    activeBrandContext: {
      cspConfiguration: { faqRedirection }
    }
  } = useContext(BrandContext);

  const handleEditNameFAQ = () => {
    navigate(
      `${CSPUrlsMap.helpCentre.url}?category=${createAlias(faqRedirection?.editName?.category)}&question=${createAlias(
        faqRedirection?.editName?.question
      )}`
    );
  };

  const { firstName, lastName } = policyHolder;

  return (
    <div className="policyHolderDetail">
      <h3>{numPolicyHolders === 1 ? 'My personal details' : 'Policy holders'}</h3>

      <div className="personalDetails nameDetails">
        <div className="fieldGroup">
          <div className="labelValueText">
            <span>
              <strong>First name</strong>
            </span>
            <span>
              <em>{firstName}</em>
            </span>
          </div>
          <div className="labelValueText">
            <span>
              <strong>Last name</strong>
            </span>
            <span>
              <em>{lastName}</em>
            </span>
          </div>
        </div>
        <button
          type="button"
          onClick={handleEditNameFAQ}
          className="button primary text_only"
        >
          <span className="labelText">Why can&rsquo;t I edit my name?</span>
        </button>
      </div>
    </div>
  );
};

NameDetails.propTypes = {
  policyHolder: PolicyHolderPropTypes,
  numPolicyHolders: PropTypes.number
};
